import React from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { BASE_URL_IMG } from "../../assets/constants";
import { useNavigate, useLocation } from "react-router";
import { useForm } from "react-hook-form";

import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { Button, Form } from "reactstrap";

import MyInputRHF from "../../MyComp/UI/form/MyInputRHF";
import MySelectRHF from "../../MyComp/UI/form/MySelectRHF";
// import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import MyButton from "../../MyComp/UI/form/MyButton";
import { useEffect, useState } from "react";
import { categoryDDAPI } from "../../api/dropdown";
import { toast } from "react-toastify";
import useLogout from "../../hooks/useLogout";
import { addMedicinesAPI } from "../../api/doctor";
import MyImageUploadRHF from "../../MyComp/UI/form/MyImageUploadRHF";
import { updateMedicineAPI } from "../../api/doctor";

const StepOne = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { mode = "Add", data } = location.state || {};

  const logout = useLogout();
  const { state } = location;

  const [categoryOptions, setCategoryOptions] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    trigger,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      name: "",
      price: "",
      original_price: "",
      tax: "",
      manufacturer: "",
      category: null,
      pack_type: null,
      status: { value: "active", label: "Active" },
      image: null,
      image_file: null,
      mode: location?.state?.mode || "Add",
    },
  });

  // const mode = watch("mode");
  const isLoading = watch("isLoading");

  const onFormSubmit = () => {
    setValue("isLoading", true);

    const formData = new FormData();

    if (mode === "Edit") {
      formData.append("medicine_id", watch("id"));
    }
    // formData.append("medicine_id", watch("medicine_id"));
    formData.append("medicine_name", watch("name"));
    formData.append("strength", watch("strength"));
    formData.append("price", watch("price"));
    formData.append("original_price", watch("original_price"));
    formData.append("manufacturer", watch("manufacturer"));
    formData.append("category", watch("category")?.label || "");
    formData.append("pack_type", watch("pack_type"));
    formData.append("tax", watch("tax"));

    const imageFile = watch("image_file");
    // console.log('file',imageFile)
    if (imageFile instanceof File) {
      formData.append("image", imageFile);
    }
    const apiCall = mode === "Edit" ? updateMedicineAPI(formData) : addMedicinesAPI(formData);

    apiCall
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) {
          toast.success(res.data.message);

          const redirectPath = state?.fromRequest ? "/medicine/medicine-request" : "/Medicine/medicine-list";

          navigate(redirectPath, { replace: true });
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setValue("isLoading", false);
      });
  };

  useEffect(() => {
    if (mode === "Edit" && data) {
      reset({
        medicine_id: data.medicine_id,
        id: data.id,
        name: data.name,
        price: data.price,
        original_price: data.original_price,
        manufacturer: data.manufacturer,
        strength: data.strength,
        pack_type: data.pack_type || "",
        image: data.image ? BASE_URL_IMG + data.image : null,
        image_file: null,
        tax: null,
      });
    }
  }, [mode, data, reset]);

  useEffect(() => {
    if (mode === "Edit" && data?.category && categoryOptions.length > 0) {
      const existingCategory = categoryOptions.find(
        (item) => item.label === data.category || item.value === data.category,
      );

      const finalCategory = existingCategory || {
        label: data.category,
        value: data.category,
      };

      if (!existingCategory) {
        setCategoryOptions((prev) => [...prev, finalCategory]);
      }

      setValue("category", finalCategory, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [mode, data, categoryOptions, setValue]);

  // console.log("API categories:", categoryOptions);
  // console.log("Edit category:", data.category);

  useEffect(() => {
    const fetchCategoryDD = async () => {
      try {
        setCategoryLoading(true);
        const res = await categoryDDAPI();
        setCategoryOptions(res.data?.data || []);
      } catch (error) {
        console.error("Category DD API Error:", error);
      } finally {
        setCategoryLoading(false);
      }
    };

    fetchCategoryDD();
  }, []);

  useEffect(() => {
    if (state) {
      if (state.medicine_name) {
        setValue("name", state.medicine_name);
      }
      if (state.id) {
        setValue("id", state.id);
      }

      if (state.strength) {
        setValue("strength", state.strength);
      }
      if (state.medicine_id) {
        setValue("medicine_id", state.medicine_id);
      }
    }
  }, [state, setValue]);

  useEffect(() => {
    const basePrice = parseFloat(watch("original_price")) || 0;
    const taxVal = parseFloat(watch("tax")) || 0;

    if (basePrice > 0 && taxVal >= 0) {
      const gstAmount = (basePrice * taxVal) / 100;
      const price = basePrice + gstAmount;

      setValue("price", Math.round(price * 100) / 100, {
        shouldValidate: true,
        shouldDirty: true,
      });

      trigger("price");
    } else {
      setValue("price", "");
    }
  }, [watch("original_price"), watch("tax"), setValue, trigger]);

  return (
    <>
      <Head title="Add Medicine" />
      <Content>
        {/* Header */}
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {mode} Medicine
              </BlockTitle>
            </BlockHeadContent>

            <BlockHeadContent>
              <Button
                color="primary"
                outline
                onClick={() => {
                  const backPath = state?.fromRequest ? "/medicine/medicine-request" : "/Medicine/medicine-list";
                  navigate(backPath);
                }}
              >
                <Icon name="arrow-left" />
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <PreviewAltCard className="p-4">
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              {/* ================= BASIC DETAILS ================= */}

              <Row className="g-3">
                <Col md="4">
                  <MyInputRHF
                    title="Medicine Name"
                    name="name"
                    placeholder="Enter medicine name"
                    register={register}
                    errors={errors}
                    required
                  />
                </Col>

                <Col md="4">
                  <MyInputRHF
                    title="Manufacturer"
                    name="manufacturer"
                    placeholder="Enter manufacturer"
                    register={register}
                    errors={errors}
                    required
                  />
                </Col>

                <Col md="4">
                  <MyInputRHF
                    name="strength"
                    title="Strength"
                    placeholder="Enter strength"
                    register={register}
                    required
                    errors={errors}
                  />
                </Col>
              </Row>

              <div className="my-4" />
              <Row className="g-3">
                <Col md="4">
                  <MySelectRHF
                    control={control}
                    setValue={setValue}
                    watch={watch}
                    name="category"
                    title="Category"
                    placeholder={categoryLoading ? "Loading categories..." : "Select category"}
                    options={categoryOptions}
                    required
                    errors={errors}
                    isDisabled={categoryLoading}
                  />
                </Col>
                <Col md="4">
                  <MyInputRHF
                    title="Original Price"
                    name="original_price"
                    type="number"
                    placeholder="Enter original price"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col md="4">
                  <MyInputRHF
                    title="Tax"
                    name="tax"
                    type="number"
                    placeholder="Enter tax"
                    register={register}
                    errors={errors}
                    min={0}
                    max={100}
                  />
                </Col>

                <Col md="4">
                  <MyInputRHF
                    title="Price"
                    name="price"
                    type="number"
                    placeholder="Enter price"
                    register={register}
                    errors={errors}
                    required
                  />
                </Col>

                <Col md="4">
                  <MyInputRHF
                    name="pack_type"
                    title="Pack Type"
                    placeholder="Enter pack type"
                    register={register}
                    required
                    errors={errors}
                  />
                </Col>

                <Col md="4">
                  <MyImageUploadRHF
                    id="image"
                    label="Upload Image"
                    image="image_file"
                    image_url="image"
                    register={register}
                    setValue={setValue}
                    getValues={getValues}
                    watch={watch}
                    trigger={trigger}
                    errors={errors}
                    clearErrors={clearErrors}
                    required={mode === "Add"}
                    size={2048}
                  />
                </Col>
              </Row>
              {(mode === "Add" || mode === "Edit") && (
                <Row className="mt-5">
                  <Col className="d-flex justify-content-end gap-2">
                    {/* Submit Button */}
                    <MyButton isLoading={isLoading} mode={mode} type="submit" />
                  </Col>
                </Row>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default StepOne;
